import { Dot, Flex, Placement, PlacementArea, Table, Text } from '@bitrise/bitkit';
import { useReferenceElement, SeriesPointXY } from '@bitrise/bitviz';
import { TypeMetricUnit } from '@trace/types';
import React, { FunctionComponent } from 'react';
import getFormattedMillisFromInterval from '../../../../utils/metric/getFormattedMillisFromInterval';
import getFormattedMetricValue from '../../../../utils/metric/getFormattedValue';
import { scaleZero } from '../../colorScales';

interface Props {
  colorScale: (v: number) => string;
  point: null | SeriesPointXY;
  names: string[];
  unit: TypeMetricUnit;
  values: (null | number)[];
  visible: boolean;
  xLower: null | number;
  xUpper: null | number;
}

const StackedBarTooltip: FunctionComponent<Props> = (props) => {
  const { colorScale, names, point, values, visible, unit, xLower, xUpper } = props;

  const referenceElement = useReferenceElement(point);

  if (!referenceElement || xLower === null || xUpper === null) {
    return null;
  }

  return (
    <Placement
      backgroundColor="black"
      borderRadius="x1"
      minWidth="8rem"
      placement="top"
      referenceElement={referenceElement}
      style={{ pointerEvents: 'none' }}
      textColor="gray-1"
      visible={visible}
    >
      {() => (
        <PlacementArea padding="x3" withArrow>
          <Text align="middle" config="8" margin="x2" textColor="gray-4">
            {point && point.x && getFormattedMillisFromInterval(xLower, xUpper, point.x)}
          </Text>

          <Table>
            <tbody>
              {values
                .map((value, index) => (
                  <tr key={names[index]}>
                    <td>
                      <Flex alignChildrenVertical="baseline" direction="horizontal" gap="x1">
                        <Flex>
                          <Dot
                            borderColor="gray-4"
                            borderWidth="x1"
                            size="10px"
                            style={{ backgroundColor: colorScale(scaleZero(index, values.length)) }}
                          />
                        </Flex>

                        <Flex>
                          <Text config="8">{names[index]}</Text>
                        </Flex>
                      </Flex>
                    </td>

                    <td>
                      <Text config="8">{getFormattedMetricValue(unit, value)}</Text>
                    </td>
                  </tr>
                ))
                .reverse()}
            </tbody>
          </Table>
        </PlacementArea>
      )}
    </Placement>
  );
};

export default StackedBarTooltip;
